import React from "react";
import "../Navigation/css/NavBar.scss";

export default function DeprecatedRestResources() {
    return (
        <div>
            Deprecated Rest Resources
        </div>
    )
}